angular.module('cvsApp').factory('pznQuestionsModel',['cvsAppData', 'commonModel', function(CAD, CM) {
	'use strict';
	var pznQuestionsModel = function(){
		var self = this;
		var apiResponse = {};
		
		
		this.setDrugList = function(data){
			apiResponse.drugList = data;
		}	

		this.getQuestionResponse = function(){
			if(apiResponse && apiResponse.getOrderEntryDetailsResponse && apiResponse.getOrderEntryDetailsResponse.clinicalQuestions)
				return apiResponse.getOrderEntryDetailsResponse.clinicalQuestions;
		};

        this.getClinicalQuestionResponse = function(){
            if(apiResponse && apiResponse.getClinicalQuestionsResponse && apiResponse && apiResponse.getClinicalQuestionsResponse.details && apiResponse.getClinicalQuestionsResponse.details.clinicalQuestions)
                return apiResponse.getClinicalQuestionsResponse.details.clinicalQuestions;
		};

		this.getQuestionResponse = function(){
            if(apiResponse && apiResponse.getQuestionsResponse && apiResponse && apiResponse.getQuestionsResponse.details && apiResponse.getQuestionsResponse.details.prescriptionQuestions)
                return apiResponse.getQuestionsResponse.details.prescriptionQuestions;
        };

		this.isSignatureRequired = function(){
			var signatureRequiredForDelivery = false;
			if(apiResponse.hasOwnProperty('getOrderEntryDetailsResponse')){
                signatureRequiredForDelivery =  apiResponse && apiResponse.getOrderEntryDetailsResponse && apiResponse.getOrderEntryDetailsResponse.signatureRequiredForDelivery;
            }
            else if(apiResponse.hasOwnProperty('getClinicalQuestionsResponse')){
                signatureRequiredForDelivery =  apiResponse && apiResponse.getClinicalQuestionsResponse && apiResponse.getClinicalQuestionsResponse.details && apiResponse.getClinicalQuestionsResponse.details.signatureRequiredForDelivery;
			}
			else if(apiResponse.hasOwnProperty('getQuestionsResponse')){
                signatureRequiredForDelivery =  apiResponse && apiResponse.getQuestionsResponse && apiResponse.getQuestionsResponse.details && apiResponse.getQuestionsResponse.details.signatureRequiredForDelivery;
            }
			if(typeof (signatureRequiredForDelivery) === "boolean"){
            	return signatureRequiredForDelivery;
			}
			else{
                return signatureRequiredForDelivery.toLowerCase() === 'true' ? true : false;
			}

		};

		this.getResponse = function(){
			return this;
		}

		this.setResponse = function(data){
			apiResponse = data;

		}

		this.getError = function(){
			if(apiResponse.hasOwnProperty("getOrderEntryDetailsResponse") &&  (apiResponse.getOrderEntryDetailsResponse.standardResponse.status !="0000" || !apiResponse.getOrderEntryDetailsResponse.hasOwnProperty('clinicalQuestions'))){
				apiResponse.showError = this.getHeader();
				return apiResponse.showError;
			}
            if(apiResponse.hasOwnProperty("getClinicalQuestionsResponse") &&  (apiResponse.getClinicalQuestionsResponse.header.statusCode !="0000" || !apiResponse.getClinicalQuestionsResponse.hasOwnProperty('details'))){
				apiResponse.showError = this.getHeader();
                return apiResponse.showError;
			}
			if(apiResponse.hasOwnProperty("getQuestionsResponse") &&  (apiResponse.getQuestionsResponse.header.statusCode !="0000" || !apiResponse.getQuestionsResponse.hasOwnProperty('details'))){
				apiResponse.showError = this.getHeader();
                return apiResponse.showError;
            }
			else if(apiResponse.hasOwnProperty("response") && apiResponse.response.header.statusCode != "0000"){
				apiResponse.showError = apiResponse.response.header;
				return apiResponse.showError;
			}
			return "";
		}

		this.getHeader = function () {
			if(apiResponse.hasOwnProperty("getClinicalQuestionsResponse")){
                return apiResponse.getClinicalQuestionsResponse.header;
			}
			if(apiResponse.hasOwnProperty("getQuestionsResponse")){
                return apiResponse.getQuestionsResponse.header;
			}
			else{
                return apiResponse.getOrderEntryDetailsResponse.standardResponse;
			}

		}
	};
	
	return new pznQuestionsModel(); 
}]);